import { ListItem, Tooltip, Typography } from "@mui/material";

import EntityChip from "../../dynamic-views/view-management/components/fields/read-only/Chip";

export default function EntityUsersListItem({ data }) {
  const classes = "self-center px-0 py-2 text-center text-sm";
  const permissionsLabel = data.permissions.join(", ");

  return (
    <ListItem className="border-b border-gray-200 px-0 hover:bg-gray-50">
      <div className="flex w-full items-center">
        <div className="w-[20%] self-center px-0 py-2 text-left text-sm">{data.name}</div>
        <div className={`${classes} w-[24%] break-words whitespace-normal`}>{data.email}</div>
        <div className={`${classes} w-[20%]`}>{data.phone}</div>
        <div className={`${classes} flex min-w-0 w-[16%] justify-center`}>
          {data.role ? <EntityChip label={data.role} /> : <Typography className="text-sm">-</Typography>}
        </div>
        <div className={`${classes} w-[20%]`}>
          <Tooltip title={permissionsLabel || "-"}>
            <Typography className="line-clamp-2 text-sm">{permissionsLabel || "-"}</Typography>
          </Tooltip>
        </div>
      </div>
    </ListItem>
  );
}
